import { connect } from 'react-redux';
import ServiceReport from '../../components/service/ServiceReport';

const mapStateToProps = ({ report, user, salon, intl }) => ({
    showAppRecords: report.get('showAppRecords'),
    isOwner: user.get('isOwner'),
    salon: user.get('salon'),
    showArchive: salon.get('showArchive'),
    currentLanguage: intl.get('locale') || intl.get('defaultLanguage'),
    enableArchive: salon.get('settings').enableArchive,
});

export default connect(mapStateToProps)(ServiceReport);
